const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export function apiFetch(path, options = {}) {
  const token = localStorage.getItem('token');
  const headers = options.headers ? { ...options.headers } : {};
  if (token && !headers.Authorization) {
    headers.Authorization = `Token ${token}`;
  }
  return fetch(`${API_BASE_URL}${path}`, { ...options, headers });
}

export async function apiFetchText(path, options) {
  const response = await apiFetch(path, options);
  return response.text();
}
